import React,{useEffect} from 'react';
import {appGetUrlPath} from '../function_lib/common_cms';
import TextToHtml from './text_html';
import './left_img_txt_desc.css';
//import lefImg1 from '../assets/images/about-image/1.jpg';
export const Left_Img_Txt_Desc_n=(props)=>{
    
    let appPath= appGetUrlPath();
    let strResp="";
    let strBtn="";

    let strLeft="";
    let strRight="";
    let isBackgroundCol12="";
    useEffect(()=>{
        //alert("i m in props");
    },[props.lsData]);
return(<>
    {props.lsData.map((item,index)=>{
        if(item["col12"]!==""){
            if(item["col12"]==="default-image"){
                // isBackgroundCol12="bg-area1";
                isBackgroundCol12="bg-content-img1";
            }
        }
        strBtn="";

        if(item["col7"].trim()!==""){
            strBtn="<a type=\"button\" class=\"btn text-center btn-primary btn-hover-primary ml-4\" href=\""+item["col7"]+"\">"+item["col8"]+"</a>";
            if(item["col7"].trim().indexOf("#")!==-1){
                strBtn="<a type=\"button\" class=\"btn text-center btn-primary btn-hover-primary ml-4\" data-toggle=\"modal\" data-target=\""+item["col7"].trim()+"\" href=\"javascript:void(0)\">"+item["col8"]+"</a>";
            }
        }
        return(<section class={"left_img_txt_desc text-center  border-box111 "+isBackgroundCol12+" about-area pb11-70px pt11-70px"}>
            <div class="container">
            {typeof props.img_right!=="undefined"?
                <div class="row align-items-center">
                    
                    <div data-aos111="fade-up" data-aos-duration11="1000" class="col-lg-6">
                        <div class="about-left-image  mb-md-30px mb-lm-30px">
                            <img  src={appPath+item["col4"]} alt="img_div" class="img-responsive w-100" />
                        </div>
                    </div>
                    <div data-aos11="fade-right" data-aos-duration11="1000" class="col-lg-6">
                        <div class="about-content">
                            <div class="about-title heading">
                                {item["col1"].trim()!==""?<h3 class="text-uppercase text-center running-underline title">{item["col1"]}</h3>:''}
                                
                            </div>
                            <p class="mb-6">
                            <TextToHtml text={item["col2"]}/>
                            </p>
                            <p>
                               { strBtn}
                            </p>
                        </div>
                   </div>
                   {item["col3"].trim()!==""?
                   <div class="col-12">
                    <TextToHtml text={item["col3"]}/>
                   </div>
                   :''}
                </div>:<div class="row align-items-center">
                    
                   
                    <div class="col-lg-6">
                        <div data-aos11="fade-left" data-aos-duration11="1000" class="about-content">
                            <div class="about-title">
                                <h3>{item["col1"]}</h3>
                            </div>
                            <p class="mb-6">
                            <TextToHtml text={item["col2"]+item["col3"]}/>
                            </p>
                            <p>
                               { strBtn}
                            </p>
                        </div>
                   </div>
                   <div class="col-lg-6">
                        <div data-aos11="fade-up" data-aos-duration11="2000" class="about-left-image  mb-md-30px mb-lm-30px">
                            <img  src={appPath+item["col4"]} alt="img_div" class="img-responsive w-100" />
                        </div>
                    </div>
                </div>
                
                }
            </div>
            </section>)
    })}
</>)

}
export function Left_Img_Txt_Desc(lsData,lsType="left"){
    var appPath= appGetUrlPath();
    var strResp="";
    let strBtn="";

    let strLeft="";
    let strRight="";
    let isBackgroundCol12="";
    for(var i=0;i<lsData.length;i++){
        if(lsData[i]["col12"]!==""){
            if(lsData[i]["col12"]==="default-image"){
                isBackgroundCol12="bg-area1";
            }
        }
        strBtn="";

        if(lsData[i]["col7"].trim()!==""){
            strBtn="<a type=\"button\" class=\"btn text-center btn-primary btn-hover-primary ml-4\" href=\""+lsData[i]["col7"]+"\">"+lsData[i]["col8"]+"</a>";
            if(lsData[i]["col7"].trim().indexOf("#")!==-1){
                strBtn="<a type=\"button\" class=\"btn text-center btn-primary btn-hover-primary ml-4\" data-toggle=\"modal\" data-target=\""+lsData[i]["col7"].trim()+"\" href=\"javascript:void(0)\">"+lsData[i]["col8"]+"</a>";
            }
        }
strLeft="<section class=\"left_img_txt_desc text-center border-box111 "+isBackgroundCol12+" about-area pb-70px pt-70px\">"+
"<div class=\"container\">"+
    "<div class=\"row align-items-center\">"+
        "<div class=\"col-lg-6\">"+
            "<div class=\"about-left-image  mb-md-30px mb-lm-30px\" >"+
                "<img  src=\""+appPath+lsData[i]["col4"]+"\" alt=\"img_div\" class=\" img-responsive w-100\" />"+
            "</div>"+
        "</div>"+
        "<div class=\"col-lg-6\">"+
            "<div class=\"about-content\">"+
                "<div class=\"about-title\">"+
                    "<h3>"+lsData[i]["col1"]+"</h3>"+
                "</div>"+
                "<p class=\"mb-6\">"+
                   lsData[i]["col2"]+lsData[i]["col3"]+
                "</p>"+
                "<p>"+
                    strBtn+
                "</p>"+
            "</div>"+
       "</div>"+
    "</div>"+
"</div>"+
"</section>";

strRight="<section class=\"left_img_txt_desc border-box-none about-area "+isBackgroundCol12+" pb-70px pt-70px\">"+
"<div class=\"container\">"+
    "<div class=\"row align-items-center\">"+
       
        "<div class=\"col-lg-6\">"+
            "<div class=\"about-content\">"+
                "<div class=\"about-title\">"+
                    "<h3>"+lsData[i]["col1"]+"</h3>"+
                "</div>"+
                "<p class=\"mb-6\">"+
                   lsData[i]["col2"]+lsData[i]["col3"]+
                "</p>"+
                "<p>"+
                    strBtn+
                "</p>"+
            "</div>"+
       "</div>"+
       "<div class=\"col-lg-6\">"+
       "<div class=\"about-left-image text-center mb-md-30px mb-lm-30px\">"+
           "<img src=\""+appPath+lsData[i]["col4"]+"\" alt=\"img_div\" class=\" img-responsive w-100\" />"+
       "</div>"+
   "</div>"+
    "</div>"+
"</div>"+
"</section>";

//alert(lsData[i]["col7"].trim());
if(lsType==="left"){
    if(i%2==0){
        
        strResp+=strLeft;
    }else{
        strResp+=strRight;
    }
}else{
    if(i%2==0){
        
        strResp+=strRight;
    }else{
        strResp+=strLeft;
    } 
}
      
        
    }
    return strResp;
}

export default Left_Img_Txt_Desc_n;